import React, { useContext, useRef } from "react";
import styled from "styled-components";
import Card from "./Card";
import { CardContext } from "./context/CardContext";

const Home = (props) => {
	const { question, setQuestion } = props;
	const { setCardData, setFlipped, setRandomNum } = useContext(CardContext);
	const domTarget = useRef(null);

	const onGetCard = () => {
		setCardData({});
		setRandomNum(Math.floor(Math.random() * 22));
		setFlipped((state) => !state);
	};

	const handleQuestion = (e) => {
		setQuestion(e.target.value);
	};
	return (
		<>
			<Wrapper>
				<InnerContentWrapper>
					<Title>Ask The Tarot</Title>
					<QuestionForm>
						<QuestionLabel>
							Ask a question, then tap the card to see what the tarot says.
						</QuestionLabel>
						<QuestionInput value={question} onChange={handleQuestion} />
					</QuestionForm>
					<Card
						onGetCard={onGetCard}
						domTarget={domTarget}
						question={question}
						setQuestion={setQuestion}
					/>
				</InnerContentWrapper>
			</Wrapper>
		</>
	);
};

export default Home;

const Wrapper = styled.div`
	padding: 32px;
	margin-bottom: 64px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const InnerContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Title = styled.h1`
	font-family: var(--font-titles);
	color: var(--text-color);
	text-align: center;
	font-size: 6rem;
	font-weight: 400;
`;

const QuestionForm = styled.form`
	min-height: 108px;
	text-align: center;
`;

const QuestionLabel = styled.label`
	font-size: 2rem;
	display: block;
	margin: 32px 32px 16px 32px;
	color: var(--text-color);
`;

const QuestionInput = styled.textarea`
	min-width: 450px;
	max-width: 450px;
	min-height: 60px;
	font-size: 1.5rem;
	border-radius: 0;

	@media screen and (max-width: 495px) {
		min-width: 80vw;
	}
`;
